<template>
  <div>
    <b-container fluid>
      <!--<b-row>
        <b-col cols="12">
          <b-button class="text-right btn-blue">
            Cargar fotos
          </b-button>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col md="6" lg="6">
          <div class="border-dashed">
            <div
              class="dropzone-container"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <input
                type="file"
                multiple
                name="file"
                id="fileInput"
                class="hidden-input"
                @change="onChange"
                ref="file"
                accept=".pdf,.jpg,.jpeg,.png"
              />

              <label for="fileInput" class="file-label">
                <div v-if="isDragging">Release to drop files here.</div>
                <div v-else class="vertical-align-middle">
                  <b-row>
                    <b-col
                      md="3"
                      class="border-all-green padding-none-lr center-div "
                    >
                      <font-awesome-icon
                        style="color:#19BE2B"
                        icon="arrow-up"
                        class="text-center"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <div
                      class="text-center"
                      style="font-size:13px;color:#405568"
                    >
                      Arrastra las fotos aquí para que se carguen
                    </div>
                  </b-row>
                </div>
              </label>
            </div>
          </div>
        </b-col>
        <b-col md="6" lg="6">
          <p class="font-weight-500">Subir fotos</p>
          <span>Debes subir un mínimo de 3 fotos</span>
          <div v-if="files.length">
            <b-list-group>
              <b-list-group-item
                class="d-flex justify-content-between align-items-center"
                style="font-size:13px"
                v-for="file in files"
                :key="file.name"
              >
                {{ file.name }}
                {{ Math.round(file.size / 1000) + "kb" }}
                <b-badge @click="remove(files.indexOf(file))">x</b-badge>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="padding-six-top">
        <b-col md="9" class="center-col">
          <b-row>
            <b-col lg="6" class="padding-left-none">
              <b-button
                class="width-100 bg-color-white border-black-all color-gray"
                @click="$bvModal.hide('modal-photos')"
              >
                Cancelar
              </b-button>
            </b-col>
            <b-col lg="6" class="padding-rigth-none">
              <b-button class="btn-dark width-100" @click="uploadImage">
                Confirmar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "Photos",
  data() {
    return {
      isDragging: false,
      files: [],
      imageBase: [],
      photos: [],
      filename: "",
    };
  },
  props: {
    idRoute: {
      type: Number,
    },
  },
  computed: {
    ...mapState("module", ["username"]),
  },
  methods: {
    remove(i) {
      this.files.splice(i, 1);
    },
    onChange() {
      this.files = [...this.$refs.file.files];
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    async uploadImageRoute() {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BASE_ONETRACK+"/route/Photo",
          this.photos,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        this.$bvModal.hide("modal-photos");
      } catch (e) {
        console.log(e);
      }
    },

    async uploadImage() {
       this.$store.commit("SET_LOADING", true);
      const listSrc = [];
      for (var i = 0; i < this.files.length; i++) {
        let res = await this.getFile(this.files[i]);
        console.log(res);
        listSrc.push({
          src: res.src,
          filename: res.filename,
        });
      }

      for (var x = 0; x < listSrc.length; x++) {
        let response = await axios.post(
          process.env.VUE_APP_BASE_ONETRACK_EXT+"/upload-photo",
          {
            user: this.username,
            image: listSrc[x].src,
            type: "photo",
            filename: listSrc[x].filename,
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        this.photos.push({
          idRoute: this.idRoute,
          idOsDet: 100,
          photoUrl: response.data.imageUrl,
          username: this.username,
        });
      }

      await this.uploadImageRoute();
      this.$store.commit("SET_LOADING", false);
    },
    async getFile(file) {
      //const file = this.files[0];
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onload = (ev) => {
          let data = {
            src: ev.target.result,
            filename: file.name,
          };
          resolve(data);
        };
        reader.readAsDataURL(file);
      });
    },
  },
};
</script>

<style>
.padding-three-top {
  padding-top: 2%;
}
.border-dashed {
  border: 1px dashed #f7f7f7;
  border-radius: 6px;
}
.btn-blue {
  background-color: #1b8cf3 !important;
  color: white !important;
  border-color: #1b8cf3 !important;
  border-radius: 4px;
}
.btn-blue:hover {
  color: #1b8cf3 !important;
  background: white !important ;
}

.dropzone-container {
  padding: 2.5rem;
  background: #fafafa;
  border: 1px dashed #c0c0c0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}
.badge {
  border-radius: none !important;
  background-color: transparent !important;
  color: #686868 !important;
}
.list-group-item {
  border: none !important;
}
.border-all-green {
  border: 1px solid #19be2b;
}
.vertical-align-middle {
  display: table-cell !important;
  vertical-align: middle !important;
}
.center-div {
  float: none;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
</style>
